export enum CustomerDetailsEnum {
  New = 1,
  Details = 2
}
